import { SET_OPEN_MODAL } from 'actions/ModalActions'

function initialState() {
  return {
    isOpen: false,
  }
}

export default function modalReducer(state = initialState(), action) {
  switch (action.type) {
    case SET_OPEN_MODAL:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
